export default __webpack_public_path__ + "static/media/icon-contact-faqs@2x.185f49bb.svg";